import { createUseStyles } from 'react-jss';

export const LoaderStyle = createUseStyles({
    loaderContainer: {
        textAlign: 'center',
        marginTop: '20px',
    },
});
